var LongObjectEditModal = (function (base) {
  __extends(LongObjectEditModal, base);


  function LongObjectEditModal(apiClient) {
    const self = base.call(this, apiClient) || this;
    return self;
  };


  LongObjectEditModal.prototype.activate = function (longObjectId) {
    const self = this;
    const isNew = !longObjectId;
    const url = isNew ? `api/longObjects/add` : `api/longObjects/${longObjectId}/edit`;

    this.loadContent(url)
      .then($modal => {

        var $form = $('form', $modal);
        const addRoadTableId = 'longobject-road-table';

        FormHelper.init($form, isNew ? 'PUT' : 'POST', 'api/longObjects');
        FilesUploader.initUploadingOnSubmit(VideoServerSettings.url, $form, "UploadedFile",
          function () {
            const type = $('#TypeId', $form).val();
            return type === '5';
          },
          function (fileType) {
            const type = $('#TypeId', $form).val();
            return type === '5' && fileType === 2 || type !== '5' && (fileType === 2 || fileType === 3);
          });

        var table = $(`#${addRoadTableId}`).DataTable({
          language: {
            url: Url.content("Content/Inspinia/plugins/dataTables/languages/Russian.json")
          },
          processing: true,
          serverSide: false,
          searching: false,
          bFilter: false,
          columnDefs: [{
            "orderable": false,
            "className": '',
            "targets": 0
          },
          {
            "orderable": false,
            "className": '',
            "targets": 1
          },
          {
            "orderable": false,
            "className": '',
            "targets": 2
          }],
          rowReorder: true,
          order: false,
          paging: false
        });

        $modal

          //Кнопка `Сохранить`
          .on('click', '[js=save]', function () {
            $modal.busy();
            $form.send()
              .then(() => self.close({ ok: true }))
              .catch(() => $modal.busy(false));
          })

            // При смене вида объекта проверить обязательность наличия файла
            .on('change', '#TypeId', () => {
                $form.find('.fileinput').trigger('update.bs.fileinput');
            })

          //Выбор кода автодороги
          .on('change', '#SelectedLongObjectWithRoad_RoadId', () => {
            updateRoadCoordinateWithPosition();
          })

          //Обновление координат при смене позиции первого и последнего км на АД
          .on('change', '#SelectedLongObjectWithRoad_StartKm', function () {
            updateRoadCoordinateWithPosition();
          })
          .on('change', '#SelectedLongObjectWithRoad_StopKm', function () {
            updateRoadCoordinateWithPosition();
          })

          //Кнопка `Задать координату на карте`
          .on('click', '[js=edit-coordinates]', () => {

            const roadId = Number($('#SelectedLongObjectWithRoad_RoadId', $modal).val());
            const startKm = parseFloat($('#SelectedLongObjectWithRoad_StartKm', $modal).val());
            const stopKm = parseFloat($('#SelectedLongObjectWithRoad_StopKm', $modal).val());
            const roadStartKm = coordinates.getRoadStartKm(roadId);
            const longObjectName = $('#Name', $modal).val();

            ModalConductor.activate(LongObjectMapModal, longObjectId, roadId, longObjectName, roadStartKm, startKm, stopKm)
              .on('closed',
                modalResult => {
                  if (modalResult.ok) {
                    $('#SelectedLongObjectWithRoad_CoordinatesCsv', $modal).val(modalResult.coordinatesSvg);
                    $('#SelectedLongObjectWithRoad_StartKm', $modal).val(modalResult.startKm);
                    $('#SelectedLongObjectWithRoad_StopKm', $modal).val(modalResult.stopKm);
                  }
                });
          })

          // Добавление дороги для ПО
          .on('click', '#addRoadData', function () {
            var $control = $(this);
            if ($control.attr('disabled') === undefined) {
              $(`#${addRoadTableId}_processing`, $modal).attr('style', 'display:block');
              $control.attr('disabled', 'disabled');
              const url = isNew ? `api/longObjects/add/roads` : `api/longObjects/${longObjectId}/edit/roads`;
              self.apiClient.post(url, {
                RoadId: $('#SelectedLongObjectWithRoad_RoadId', $modal).val(),
                StartKm: $('#SelectedLongObjectWithRoad_StartKm', $modal).val(),
                StopKm: $('#SelectedLongObjectWithRoad_StopKm', $modal).val(),
                CoordinatesCsv: $('#SelectedLongObjectWithRoad_CoordinatesCsv', $modal).val(),
                LongObjectTypeId: $('#TypeId', $modal).val()
              })
              .then(result => {
                $(`#${addRoadTableId}_processing`, $modal).attr('style', 'display:none');
                $control.removeAttr('disabled');
                if (result.result) {
                  initTable({
                    row: [
                      result.result.Road.Code,
                      result.result.StartKm,
                      `<div class="input-group">${result.result.StopKm}<span class="input-group-btn"> <a class="pull-right btn btn-sm btn-default no-borders" js="delete-road" data-id="${result.result.RoadId}" data-startkm="${result.result.StartKm}" data-stopkm="${result.result.StopKm}" data-row="${$('#' + addRoadTableId).DataTable().rows()[0].slice(-1)[0]}"><i class="fa fa-minus"></i></a> </span> </div>`
                    ],
                    id: addRoadTableId
                  });
                  $('#HasRoads').val('true');
                  $('#HasRoads').trigger('check.validation');
                } else {
                  if (result.error) {
                    $.each($('.text-danger', $modal),
                      function (idx, obj) {
                        if ($(obj).data('valmsgFor') == result.error.field) {
                          $(obj).text(result.error.text);
                        }
                        $('#' + result.error.field.replace('.', '_'))
                          .on('change',
                            function () {
                              $(obj).text('');
                            });
                      });
                  }
                }
              });
            }
          })

          // Удаление дороги из ПО
          .on('click', '[js=delete-road]', function () {
            var $control = $(this);
            $(`#${addRoadTableId}_processing`, $modal).show();
            $control.prop('disabled', true);
            const url = isNew ? `api/longObjects/add/roads` : `api/longObjects/${longObjectId}/edit/roads`;

            self.apiClient.delete(url, {
              RoadId: $control.data('id'),
              StartKm: $control.data('startkm'),
              StopKm: $control.data('stopkm'),
              Row: $control.closest('tr').attr('id')
            })
          .then(function (result) {
            $(`#${addRoadTableId}_processing`, $modal).hide();

            if (result.result) {
                var table = $(`#${addRoadTableId}`).DataTable();
                table.row(`#${result.result}`).remove().draw(false);
                var isEmpty = table.row(':not(.longobject-road-table-tr):not(.table-data-empty)').count() === 0;
                if (isEmpty)
                    $('#HasRoads').val('');
                $('#HasRoads').trigger('check.validation');
            }
            $control.prop('disabled', false);
          });
          });
      });
  };

  function updateRoadCoordinateWithPosition() {
    const roadId = $("#SelectedLongObjectWithRoad_RoadId option:selected").val();
    coordinates.reloadRoadCoordinates(roadId || 0).then(function () {
      coordinates.updateCoordinates({ isPoint: false });
    });
  }

  function initTable(option) {

    const table = $(`#${option.id}`).DataTable();

    if (option.row) {
      table.row('.table-data-empty').remove().draw(false);
      var controlRow = table.row('.longobject-road-table-tr').data();

      table.row('.longobject-road-table-tr').remove().draw(false);
      table.row.add(option.row).draw(false);
      table.row.add(controlRow).draw();

      table.rows().every(function (rowIdx) {
        const control = this.node();
        const data = this.data();

        $(control).attr('id', `row_${rowIdx}`);

        if (data == controlRow) {
          $(control).addClass('longobject-road-table-tr');
        }
      });
    }
  };

  return LongObjectEditModal;
}(BaseModal));
